import React from 'react'
import { StyleSheet } from '@react-pdf/renderer'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'
import { Line } from './Line'
import Text from './Text'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    margin: '20px 0 8px 52px',
    flexGrow: 1,
    maxWidth: 543,
  },
  verticalLine: {
    backgroundColor: colors.strongGreen,
    width: 4,
    minWidth: 4,
    height: 26,
    borderRadius: 8,
  },
  line: {
    marginBottom: 8,
    marginLeft: 52,
    maxWidth: 543,
  },
  text: {
    color: colors.strongGray,
    fontSize: 12,
    margin: 0,
  },
})

const NoRiskMessage = ({ title, text }) => (
  <div>
    <div style={styles.container}>
      <div style={styles.verticalLine} />
      <div style={{ marginLeft: 16 }}>
        <Text style={styles.text}>
          <b>{title}</b>
          {text}
        </Text>
      </div>
    </div>
    <Line style={styles.line} />
  </div>
)

NoRiskMessage.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

export default NoRiskMessage
